import { resolveMedia } from "@/lib/api";

/**
 * Immagine con punto focale (X/Y %), zoom e variante mobile opzionale,
 * pilotata dalle impostazioni globali con prefisso (es. "home_stp", "shop_hero", "stp_page").
 */
export function FocalImage({ settings, prefix, fallback = "", alt = "", className = "", pictureClassName = "", loading = "lazy", ariaHidden = false }) {
  const desk = settings?.[`${prefix}_image`] ? resolveMedia(settings[`${prefix}_image`]) : fallback;
  const mob = settings?.[`${prefix}_image_mobile`] ? resolveMedia(settings[`${prefix}_image_mobile`]) : "";
  if (!desk) return null;
  const fx = Number(settings?.[`${prefix}_focal_x`] ?? 50);
  const fy = Number(settings?.[`${prefix}_focal_y`] ?? 50);
  const zoom = Math.min(200, Math.max(100, Number(settings?.[`${prefix}_zoom`]) || 100)) / 100;
  return (
    <picture className={pictureClassName || "block"}>
      {mob && <source media="(max-width: 767px)" srcSet={mob} />}
      <img
        src={desk}
        alt={ariaHidden ? "" : (settings?.[`${prefix}_alt`] || alt)}
        aria-hidden={ariaHidden || undefined}
        loading={loading}
        className={className}
        style={{ objectPosition: `${fx}% ${fy}%`, transform: zoom > 1 ? `scale(${zoom})` : undefined }}
      />
    </picture>
  );
}
